import classNames from 'classnames';
import { t } from 'ttag';

import OutletLogo from '@svg/outlet-logo.svg';
import { useAppContext } from '@contexts/AppContext';
import { ShafaLogo } from '@ui/ShafaLogo';

import s from './HeaderSimple.sss';

interface Props {
  className?: string,
  isLinkifyLogo?: boolean,
}

export const HeaderSimple: React.FC<Props> = ({
  className,
  isLinkifyLogo = true,
}) => {
  const { isOutlet } = useAppContext();

  const logo = isOutlet ? (
    <>
      <OutletLogo
        className={s.outletLogo}
        width="159"
        height="48"
      />
    </>
  ) : (
    <>
      <ShafaLogo
        width="126px"
        height="36px"
      />
      <span className={s.iconSpan}>
        {t`Речі за кліком серця`}
      </span>
    </>
  );

  return (
    <div className={classNames(s.root, className)}>
      {isLinkifyLogo ? (
        <a
          className={s.link}
          href="/"
        >
          {logo}
        </a>
      ) : (
        <div className={s.link}>
          {logo}
        </div>
      )}
    </div>
  );
};

export default HeaderSimple;
